<script setup lang="ts">
import { autoResize } from "@/composables/useGeneric"

interface Props {
  id: string
  modelValue: string
  rows?: number
  maxLength?: number
  placeholder?: string
  isLoading?: boolean
  name?: string
  feedback?: string
}
withDefaults(defineProps<Props>(), {
  rows: 4,
  maxLength: 0,
  placeholder: "",
  isLoading: false,
  name: "",
  feedback: ""
})

const emit = defineEmits(["update:modelValue"])
const updateValue = (event: Event) => {
  autoResize(event)
  emit("update:modelValue", (event.target as HTMLInputElement).value)
}
</script>

<template>
  <textarea
    :id="id"
    :rows="rows"
    :name="name"
    :value="modelValue"
    :placeholder="placeholder"
    :maxlength="maxLength > 0 ? maxLength : ''"
    :readonly="isLoading"
    :class="[
      isLoading && 'opacity-50',
      feedback
        ? 'border-error focus:border-error'
        : 'border border-gray-300 dark:border-gray-700 focus:border-gray-300 focus:dark:border-gray-700'
    ]"
    class="block w-full min-h-[38px] p-2 placeholder-placeholderText rounded-md shadow-sm appearance-none input dark:bg-gray-700 focus:outline-1 focus:outline-gray-200 focus:dark:outline-gray-700 focus:ring-0 focus:ring-transparent sm:text-sm overflow-y-hidden resize-y disabled:opacity-50 disabled:cursor-not-allowed read-only:cursor-not-allowed"
    @input="updateValue"
  />
</template>
